import cn from 'clsx';

import type {ImageModel, VideoModel} from '@/types/content';
import Media from '../Media/Media';

type AnimatedMediaBackgroundProps = {
    isPopupOpen?: boolean;
    selectedTile?: unknown;
    isStatic?: boolean;
    mainImage?: ImageModel | ImageModel[];
    secondImage?: ImageModel | ImageModel[];
    video?: VideoModel;
    bgColor?: string;
};

const toImagesArray = (image?: ImageModel | ImageModel[]): ImageModel[] => {
    if (!image) return [];
    return Array.isArray(image) ? image : [image];
};

const AnimatedMediaBackground = ({
    isPopupOpen,
    selectedTile,
    isStatic,
    mainImage,
    secondImage,
    video,
    bgColor,
}: AnimatedMediaBackgroundProps) => {
    const hasVideo = Boolean(video);
    const isAnimatedBackground = !hasVideo && !isStatic;
    const hasSelectedTile = Boolean(selectedTile);

    const mainImages = toImagesArray(mainImage);
    const secondaryImages = toImagesArray(secondImage);

    return (
        <div className='pointer-events-none absolute inset-0 flex h-[calc(100vh-var(--global-hw-h))] flex-col items-center justify-center overflow-hidden pt-0'>
            <Media
                bgColor={bgColor}
                images={mainImages}
                videos={video}
                videoClassName='object-contain'
                containerClassName='h-full w-full'
                imgContainerClassName='w-full h-full'
                pictureClassName='w-full h-full'
                imgClassName='w-full h-full object-contain'
                className={cn(
                    'w-full object-contain',
                    isAnimatedBackground
                        ? cn(
                              'my-auto max-h-[80dvh] transition-[transform,opacity] duration-500 ease-in-out will-change-[transform,opacity]',
                              !isPopupOpen && 'max-h-[75dvh] w-[70vw] -translate-y-[12vh]',
                              isPopupOpen &&
                                  !hasSelectedTile &&
                                  'z-10 w-[35vw] translate-y-[50px] rotate-0 opacity-100',
                              isPopupOpen && hasSelectedTile && 'z-0 w-[35vw] translate-y-[50px] opacity-0'
                          )
                        : 'z-0 flex min-h-0 flex-1 flex-col',
                    hasVideo && 'h-full'
                )}
                videoLoop={false}
            />
            {isPopupOpen && isAnimatedBackground && (
                <Media
                    images={secondaryImages}
                    className={cn(
                        'absolute max-h-[80dvh] translate-y-[50px] object-contain transition-opacity duration-500 ease-in-out will-change-[opacity]',
                        hasSelectedTile ? 'z-10 opacity-100' : 'z-0 opacity-0'
                    )}
                    videoLoop={false}
                />
            )}
        </div>
    );
};

export default AnimatedMediaBackground;
